const BookDemoForm = (el) => {
  // submit
  const button = el.querySelector("input[type='submit']");
  if (button) button.disabled = true;

  const init = () => {
    const inputs = [...el.querySelectorAll("input")];

    const checkAllRequired = () => {
      let valid = true;
      inputs
        .filter((input) => input.hasAttribute("required"))
        .forEach((input) => {
          if (!input.checkValidity()) {
            valid = false;
          }
          if (
            input.required &&
            (input.value === "" || input.value === undefined)
          ) {
            valid = false;
          }
        });
      return valid;
    };
    // check to see if all are valid, if so, enable the submit button
    inputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        if (checkAllRequired()) {
          if (button) button.disabled = false;
        } else {
          if (button) button.disabled = true;
        }
      });
    });
  };

  setTimeout(() => {
    init();
  }, 100);

  //   el.addEventListener("submit", (e) => {});
};
export default BookDemoForm;
